import { object, string } from "yup"

export default object({
  value: string().required(),
})
